import { render, staticRenderFns } from "./priceSign.vue?vue&type=template&id=0d1a87b0&scoped=true"
import script from "./priceSign.vue?vue&type=script&lang=js"
export * from "./priceSign.vue?vue&type=script&lang=js"
import style0 from "./priceSign.vue?vue&type=style&index=0&id=0d1a87b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a87b0",
  null
  
)

export default component.exports